var _path, _path2, _path3, _path4, _circle, _circle2, _g, _path5, _circle3, _circle4, _g2, _path6, _circle5, _circle6, _g3, _path7, _circle7, _circle8, _g4, _path8, _ellipse, _ellipse2, _g5, _path9, _path0, _ellipse3, _ellipse4, _g6, _path1, _ellipse5, _ellipse6, _g7, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgLogoChannels = function SvgLogoChannels(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125 125",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 63.2653V94.8318C22 97.135 24.4879 98.5791 26.4878 97.4369L87.4878 62.5983C88.4229 62.0643 89 61.0701 89 59.9933V30.1682C89 27.865 86.5121 26.4209 84.5122 27.5631L55.5 44.1327",
    stroke: "#91EEFF",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 98.454C51.5 100.795 54.0622 102.234 56.0614 101.016L102.561 72.6727C103.455 72.1282 104 71.1574 104 70.1111V43.3419C104 41.0007 101.438 39.5617 99.4386 40.7803L52.9386 69.1231C52.0452 69.6677 51.5 70.6384 51.5 71.6848V98.454Z",
    stroke: "#91EEFF",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 23.1264C33 20.8326 35.4696 19.3874 37.4694 20.5109L75.9694 42.1401C76.9148 42.6712 77.5 43.6712 77.5 44.7556V101.823C77.5 104.128 75.0084 105.572 73.0084 104.426L34.5084 82.3644C33.5755 81.8298 33 80.8367 33 79.7615V23.1264Z",
    fill: "url(#logo-channels_svg__paint0_linear_1_24)",
    stroke: "url(#logo-channels_svg__paint1_linear_1_24)",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M33 23.1963C33 20.8868 35.5001 19.4435 37.5001 20.5982L72.813 40.9871C73.7533 41.53 73.2672 43.5958 72.2041 43.8167C67.4873 44.797 59.8177 47.8437 51.6078 57.0358C44.0923 65.4505 37.8902 74.4655 34.9098 79.0114C34.356 79.8561 33 79.456 33 78.4461V23.1963Z",
    fill: "url(#logo-channels_svg__paint2_linear_1_24)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104.223,
    cy: 59.8657,
    r: 6.86573,
    fill: "url(#logo-channels_svg__paint3_linear_1_24)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-channels_svg__mask0_1_24",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 53,
    width: 15,
    height: 14
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.223,
    cy: 59.8657,
    r: 6.86573,
    fill: "url(#logo-channels_svg__paint4_linear_1_24)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-channels_svg__mask0_1_24)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter0_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.06 62.5376C106.786 64.8465 107.06 57.6406 104.916 55.5294C102.772 53.4182 99.0217 57.2012 101.295 54.8922C103.569 52.5832 107.15 52.4229 109.294 54.5341C111.438 56.6453 111.333 60.2286 109.06 62.5376Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter1_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.547 55.7546C111.278 58.2871 103.459 57.7155 101.398 59.9387C99.3368 62.1618 103.815 66.3378 101.083 63.8054C98.3515 61.2729 97.8077 57.4177 99.8687 55.1946C101.93 52.9714 105.815 53.2221 108.547 55.7546Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter2_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.4383 63.4998C98.614 62.1668 102.576 64.9181 105.208 65.2649C107.839 65.6116 108.144 63.4225 107.968 64.7555C107.792 66.0885 105.517 66.8881 102.885 66.5413C100.254 66.1945 98.2627 64.8328 98.4383 63.4998Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter3_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.164 61.7559C107.795 65.3513 105.267 59.12 103.327 58.9211C101.387 58.7222 100.77 64.6311 101.138 61.0357C101.507 57.4403 103.378 54.6869 105.318 54.8858C107.258 55.0847 108.532 58.1606 108.164 61.7559Z",
    fill: "#91EEFF"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.827 53.5846C102.589 53.2938 98.089 54.2932 97.9951 60.6165C98.422 58.4963 100.386 54.1216 104.827 53.5846Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.961,
    cy: 62.651,
    r: 4.65097,
    fill: "url(#logo-channels_svg__paint5_linear_1_24)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-channels_svg__mask1_1_24",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 58,
    width: 10,
    height: 10
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9609,
    cy: 62.651,
    r: 4.65097,
    fill: "url(#logo-channels_svg__paint6_linear_1_24)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-channels_svg__mask1_1_24)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter4_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2374 64.4609C23.6973 66.0251 23.8825 61.1437 22.43 59.7135C20.9775 58.2833 18.4373 60.846 19.9774 59.2819C21.5175 57.7177 23.9435 57.6091 25.396 59.0393C26.8485 60.4694 26.7775 62.8968 25.2374 64.4609Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter5_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8898 59.866C26.7403 61.5815 21.4431 61.1944 20.0469 62.7004C18.6508 64.2064 21.6844 67.0353 19.8339 65.3198C17.9833 63.6042 17.615 60.9926 19.0111 59.4866C20.4073 57.9806 23.0392 58.1505 24.8898 59.866Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter6_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0421 65.1128C18.1611 64.2098 20.8452 66.0736 22.6279 66.3085C24.4105 66.5434 24.6167 65.0604 24.4977 65.9634C24.3787 66.8664 22.8371 67.4081 21.0545 67.1732C19.2718 66.9383 17.9231 66.0158 18.0421 65.1128Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter7_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6303 63.9315C24.3807 66.367 22.668 62.1458 21.3538 62.0111C20.0395 61.8764 19.6213 65.8791 19.871 63.4436C20.1207 61.008 21.3885 59.1428 22.7028 59.2775C24.017 59.4123 24.88 61.4959 24.6303 63.9315Z",
    fill: "#91EEFF"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3699 58.396C20.8537 58.1991 17.8054 58.876 17.7418 63.1595C18.031 61.7233 19.3615 58.7598 22.3699 58.396Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.3562,
    cy: 40.209,
    r: 2.20899,
    fill: "url(#logo-channels_svg__paint7_linear_1_24)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-channels_svg__mask2_1_24",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 38,
    width: 5,
    height: 5
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.3561,
    cy: 40.209,
    r: 2.20899,
    fill: "url(#logo-channels_svg__paint8_linear_1_24)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-channels_svg__mask2_1_24)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter8_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.9123 41.0686C90.1809 41.8115 90.2688 39.4931 89.5789 38.8138C88.8891 38.1346 87.6826 39.3517 88.4141 38.6088C89.1456 37.8659 90.2978 37.8143 90.9876 38.4936C91.6775 39.1728 91.6438 40.3257 90.9123 41.0686Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter9_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.7472 38.8863C91.6261 39.7011 89.1102 39.5172 88.4471 40.2325C87.784 40.9477 89.2248 42.2913 88.3459 41.4765C87.467 40.6617 87.292 39.4214 87.9551 38.7061C88.6182 37.9908 89.8683 38.0715 90.7472 38.8863Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter10_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.4949 41.3782C87.5514 40.9493 88.8263 41.8346 89.6729 41.9461C90.5196 42.0577 90.6175 41.3534 90.561 41.7822C90.5045 42.2111 89.7723 42.4684 88.9256 42.3568C88.079 42.2452 87.4384 41.8071 87.4949 41.3782Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter11_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.624 40.8172C90.5054 41.974 89.692 39.9691 89.0678 39.9051C88.4436 39.8411 88.245 41.7422 88.3636 40.5854C88.4821 39.4287 89.0843 38.5428 89.7085 38.6068C90.3327 38.6708 90.7426 39.6604 90.624 40.8172Z",
    fill: "#91EEFF"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5504 38.1881C88.8303 38.0945 87.3825 38.4161 87.3523 40.4505C87.4896 39.7684 88.1215 38.3609 89.5504 38.1881Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.3562,
    cy: 33.209,
    r: 2.20899,
    fill: "url(#logo-channels_svg__paint9_linear_1_24)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-channels_svg__mask3_1_24",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 31,
    width: 5,
    height: 5
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.3561,
    cy: 33.209,
    r: 2.20899,
    fill: "url(#logo-channels_svg__paint10_linear_1_24)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-channels_svg__mask3_1_24)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter12_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9123 34.0686C74.1809 34.8115 74.2688 32.4931 73.5789 31.8138C72.8891 31.1346 71.6826 32.3517 72.4141 31.6088C73.1456 30.8659 74.2978 30.8143 74.9876 31.4936C75.6775 32.1728 75.6438 33.3257 74.9123 34.0686Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter13_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.7472 31.8863C75.6261 32.7011 73.1102 32.5172 72.4471 33.2325C71.784 33.9477 73.2248 35.2913 72.3459 34.4765C71.467 33.6617 71.292 32.4214 71.9551 31.7061C72.6182 30.9908 73.8683 31.0715 74.7472 31.8863Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter14_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.4949 34.3782C71.5514 33.9493 72.8263 34.8346 73.6729 34.9461C74.5196 35.0577 74.6175 34.3534 74.561 34.7822C74.5045 35.2111 73.7723 35.4684 72.9256 35.3568C72.079 35.2452 71.4384 34.8071 71.4949 34.3782Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter15_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.624 33.8172C74.5054 34.974 73.692 32.9691 73.0678 32.9051C72.4436 32.8411 72.245 34.7422 72.3636 33.5854C72.4821 32.4287 73.0843 31.5428 73.7085 31.6068C74.3327 31.6708 74.7426 32.6604 74.624 33.8172Z",
    fill: "#91EEFF"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5504 31.1881C72.8303 31.0945 71.3825 31.4161 71.3523 33.4505C71.4896 32.7684 72.1215 31.3609 73.5504 31.1881Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.4229,
    cy: 81.209,
    rx: 3.20899,
    ry: 3.20899,
    fill: "url(#logo-channels_svg__paint11_linear_1_24)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-channels_svg__mask4_1_24",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 78,
    width: 7,
    height: 7
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.4228,
    cy: 81.209,
    rx: 3.20899,
    ry: 3.20899,
    fill: "url(#logo-channels_svg__paint12_linear_1_24)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-channels_svg__mask4_1_24)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter16_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.6834 82.4578C88.6208 83.537 88.7486 80.169 87.7464 79.1822C86.7443 78.1955 84.9916 79.9636 86.0542 78.8844C87.1168 77.8052 88.7907 77.7303 89.7928 78.717C90.795 79.7038 90.746 81.3786 89.6834 82.4578Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter17_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.4436 79.2875C90.7204 80.4712 87.0655 80.204 86.1022 81.2431C85.1389 82.2822 87.232 84.234 85.9552 83.0504C84.6784 81.8667 84.4242 80.0648 85.3875 79.0258C86.3508 77.9867 88.1668 78.1039 89.4436 79.2875Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter18_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.719 82.9075C84.8011 82.2845 86.653 83.5704 87.883 83.7325C89.1129 83.8946 89.2552 82.8714 89.1731 83.4944C89.091 84.1175 88.0273 84.4912 86.7974 84.3291C85.5674 84.167 84.6369 83.5306 84.719 82.9075Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter19_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2646 82.0925C89.0923 83.7729 87.9107 80.8605 87.0039 80.7675C86.0971 80.6746 85.8086 83.4363 85.9808 81.7559C86.1531 80.0754 87.0279 78.7885 87.9346 78.8815C88.8414 78.9744 89.4369 80.412 89.2646 82.0925Z",
    fill: "#91EEFF"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.705 78.2732C86.6589 78.1374 84.5557 78.6044 84.5118 81.5599C84.7113 80.5689 85.6293 78.5242 87.705 78.2732Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 92.7959V59",
    stroke: "#91EEFF",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.6516,
    cy: 63,
    rx: 13.0707,
    ry: 13,
    fill: "url(#logo-channels_svg__paint13_linear_1_24)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-channels_svg__mask5_1_24",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 50,
    width: 27,
    height: 26
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.6515,
    cy: 63,
    rx: 13.0707,
    ry: 13,
    fill: "url(#logo-channels_svg__paint14_linear_1_24)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-channels_svg__mask5_1_24)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter20_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8591 68.0589C57.531 72.4309 58.0515 58.7868 53.9695 54.7893C49.8875 50.7918 42.7488 57.9548 47.0769 53.5828C51.4051 49.2108 58.2228 48.9072 62.3048 52.9047C66.3868 56.9022 66.1873 63.6869 61.8591 68.0589Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter21_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.8823 55.2157C66.0828 60.0108 51.196 58.9286 47.2724 63.1381C43.3488 67.3475 51.8743 75.2547 46.6737 70.4595C41.4731 65.6644 40.4379 58.3647 44.3615 54.1553C48.2851 49.9458 55.6817 50.4206 60.8823 55.2157Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter22_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6385 69.8811C41.9729 67.3571 49.516 72.5667 54.5258 73.2233C59.5356 73.8798 60.115 69.7348 59.7806 72.2588C59.4462 74.7828 55.1139 76.2967 50.1041 75.6401C45.0943 74.9835 41.3041 72.4051 41.6385 69.8811Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter23_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1535 66.5791C59.4518 73.3868 54.6388 61.588 50.9453 61.2114C47.2518 60.8348 46.0765 72.023 46.7782 65.2153C47.4799 58.4076 51.0429 53.1942 54.7364 53.5708C58.4298 53.9474 60.8551 59.7714 60.1535 66.5791Z",
    fill: "#91EEFF"
  })))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0911 51.1068C49.8302 50.5563 41.2636 52.4485 41.0848 64.4214C41.8974 60.4069 45.6364 52.1236 54.0911 51.1068Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.5274,
    cy: 62.8838,
    rx: 2.81089,
    ry: 2.88889,
    transform: "rotate(-180 52.5274 62.8838)",
    fill: "url(#logo-channels_svg__paint15_linear_1_24)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-channels_svg__mask6_1_24",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 59,
    width: 7,
    height: 7
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.5274,
    cy: 62.8837,
    rx: 2.81089,
    ry: 2.88889,
    transform: "rotate(-180 52.5274 62.8837)",
    fill: "url(#logo-channels_svg__paint16_linear_1_24)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-channels_svg__mask6_1_24)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter24_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5473 61.7595C51.478 60.7879 51.3661 63.8199 52.244 64.7083C53.1218 65.5966 54.657 64.0048 53.7262 64.9764C52.7954 65.9479 51.3293 66.0154 50.4514 65.1271C49.5736 64.2387 49.6165 62.731 50.5473 61.7595Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter25_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7574 64.6136C49.639 63.548 52.8404 63.7885 53.6842 62.8531C54.528 61.9177 52.6946 60.1605 53.813 61.2261C54.9314 62.2917 55.154 63.9138 54.3102 64.8493C53.4665 65.7847 51.8758 65.6792 50.7574 64.6136Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter26_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8957 61.3544C54.8238 61.9153 53.2016 60.7576 52.1242 60.6117C51.0469 60.4658 50.9223 61.387 50.9942 60.8261C51.0661 60.2652 51.9978 59.9288 53.0752 60.0747C54.1525 60.2206 54.9676 60.7935 54.8957 61.3544Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-channels_svg__filter27_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9141 62.0883C51.065 60.5754 52.1 63.1974 52.8943 63.2811C53.6886 63.3648 53.9414 60.8785 53.7905 62.3913C53.6396 63.9041 52.8733 65.0627 52.079 64.979C51.2848 64.8953 50.7632 63.6011 50.9141 62.0883Z",
    fill: "#91EEFF"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2804 65.5267C53.1967 65.649 55.039 65.2285 55.0774 62.5679C54.9027 63.46 54.0986 65.3007 52.2804 65.5267Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter0_f_1_24",
    x: 99.3854,
    y: 51.8472,
    width: 12.6534,
    height: 12.3439,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter1_f_1_24",
    x: 97.4159,
    y: 52.4756,
    width: 12.906,
    height: 13.322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter2_f_1_24",
    x: 97.2249,
    y: 61.9351,
    width: 11.9863,
    height: 5.88981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter3_f_1_24",
    x: 97.257,
    y: 51.0958,
    width: 14.7501,
    height: 15.5551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88991,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter4_f_1_24",
    x: 18.2957,
    y: 56.8311,
    width: 9.34754,
    height: 9.13789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter5_f_1_24",
    x: 16.9616,
    y: 57.2568,
    width: 9.51869,
    height: 9.80052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter6_f_1_24",
    x: 16.8321,
    y: 63.6649,
    width: 8.89564,
    height: 4.76582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter7_f_1_24",
    x: 16.0226,
    y: 55.4908,
    width: 12.4306,
    height: 12.9759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88991,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter8_f_1_24",
    x: 87.4993,
    y: 37.3288,
    width: 4.67169,
    height: 4.57211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter9_f_1_24",
    x: 86.8657,
    y: 37.531,
    width: 4.75299,
    height: 4.88684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter10_f_1_24",
    x: 86.8042,
    y: 40.5745,
    width: 4.45706,
    height: 2.49558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter11_f_1_24",
    x: 86.1711,
    y: 36.4436,
    width: 6.63325,
    height: 6.89225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07995,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter12_f_1_24",
    x: 71.4993,
    y: 30.3288,
    width: 4.67169,
    height: 4.57211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter13_f_1_24",
    x: 70.8657,
    y: 30.531,
    width: 4.75299,
    height: 4.88684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter14_f_1_24",
    x: 70.8042,
    y: 33.5745,
    width: 4.45706,
    height: 2.49558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter15_f_1_24",
    x: 70.1711,
    y: 29.4436,
    width: 6.63325,
    height: 6.89225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07995,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter16_f_1_24",
    x: 85.0365,
    y: 77.3361,
    width: 6.16434,
    height: 6.01968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter17_f_1_24",
    x: 84.116,
    y: 77.6298,
    width: 6.28241,
    height: 6.47687,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter18_f_1_24",
    x: 84.0267,
    y: 82.0511,
    width: 5.85254,
    height: 3.00311,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter19_f_1_24",
    x: 83.7736,
    y: 76.7168,
    width: 7.68058,
    height: 8.0568,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07995,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter20_f_1_24",
    x: 40.1002,
    y: 44.464,
    width: 30.7706,
    height: 30.0791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.81522,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter21_f_1_24",
    x: 36.3511,
    y: 45.6538,
    width: 31.2516,
    height: 31.9312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.81522,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter22_f_1_24",
    x: 35.9875,
    y: 63.5652,
    width: 29.5006,
    height: 17.8586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.81522,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter23_f_1_24",
    x: 28.8898,
    y: 35.8559,
    width: 49.0801,
    height: 50.5303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.84783,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter24_f_1_24",
    x: 44.1897,
    y: 55.9393,
    width: 15.4565,
    height: 15.4427,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.81522,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter25_f_1_24",
    x: 44.8925,
    y: 55.2635,
    width: 15.5599,
    height: 15.8543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.81522,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter26_f_1_24",
    x: 45.3472,
    y: 54.4102,
    width: 15.1834,
    height: 12.727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.81522,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-channels_svg__filter27_f_1_24",
    x: 33.1924,
    y: 43.9234,
    width: 38.3351,
    height: 38.7555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.84783,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint0_linear_1_24",
    x1: 50.5,
    y1: 86.5,
    x2: 35,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint1_linear_1_24",
    x1: 44,
    y1: 20.5,
    x2: 74,
    y2: 104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint2_linear_1_24",
    x1: 41,
    y1: -17.5,
    x2: 65,
    y2: 57.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0266745,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint3_linear_1_24",
    x1: 104.223,
    y1: 53,
    x2: 104.223,
    y2: 66.7315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint4_linear_1_24",
    x1: 104.223,
    y1: 53,
    x2: 104.223,
    y2: 66.7315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint5_linear_1_24",
    x1: 21.961,
    y1: 58,
    x2: 21.961,
    y2: 67.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint6_linear_1_24",
    x1: 21.9609,
    y1: 58,
    x2: 21.9609,
    y2: 67.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint7_linear_1_24",
    x1: 89.3562,
    y1: 38,
    x2: 89.3562,
    y2: 42.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint8_linear_1_24",
    x1: 89.3561,
    y1: 38,
    x2: 89.3561,
    y2: 42.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint9_linear_1_24",
    x1: 73.3562,
    y1: 31,
    x2: 73.3562,
    y2: 35.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint10_linear_1_24",
    x1: 73.3561,
    y1: 31,
    x2: 73.3561,
    y2: 35.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint11_linear_1_24",
    x1: 87.4229,
    y1: 78,
    x2: 87.4229,
    y2: 84.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint12_linear_1_24",
    x1: 87.4228,
    y1: 78,
    x2: 87.4228,
    y2: 84.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint13_linear_1_24",
    x1: 52.6516,
    y1: 50,
    x2: 52.6516,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint14_linear_1_24",
    x1: 52.6515,
    y1: 50,
    x2: 52.6515,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint15_linear_1_24",
    x1: 52.5274,
    y1: 59.9949,
    x2: 52.5274,
    y2: 65.7726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-channels_svg__paint16_linear_1_24",
    x1: 52.5274,
    y1: 59.9948,
    x2: 52.5274,
    y2: 65.7726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoChannels);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "static/logo-channels.6753f9cd.svg";